<div [hidden]="isInitialLoading">
    @if (bundle) {
        <div class="d-flex justify-content-between align-items-start mb-3">
            <div>
                <a routerLink="/field-tools/swppp">SWPPP</a>
                <h1 class="h3 mb-0">{{ bundle.site.name }}</h1>
                <div class="text-muted">{{ bundle.site.job }} · {{ bundle.site.address }}</div>
                <div>
                    Last 24h precipitation: {{ bundle.site.lastPrecip24hInches ?? '—' }} in · 48h forecast:
                    {{ bundle.site.forecast48hPrecipChance ?? '—' }}% chance of rain
                    <a [href]="sourceUrl()" target="_blank" rel="noopener">Source</a>
                </div>
            </div>
            @if (canEdit) {
                <button type="button" class="btn btn-outline-secondary btn-sm" (click)="setActive(!bundle.site.isActive)">
                    Mark {{ bundle.site.isActive ? 'inactive' : 'active' }}
                </button>
            }
        </div>

        <ul ngbNav [(activeId)]="tab" class="nav-tabs mb-3">
            <li [ngbNavItem]="0"><a ngbNavLink>Overview</a></li>
            <li [ngbNavItem]="1"><a ngbNavLink>Assignments</a></li>
            <li [ngbNavItem]="2"><a ngbNavLink>People</a></li>
            <li [ngbNavItem]="3"><a ngbNavLink>Documents</a></li>
            <li [ngbNavItem]="4"><a ngbNavLink>Inspections</a></li>
            <li [ngbNavItem]="5"><a ngbNavLink>Action items</a></li>
            <li [ngbNavItem]="6"><a ngbNavLink>Weather</a></li>
            <li [ngbNavItem]="7"><a ngbNavLink>Notes</a></li>
            <li [ngbNavItem]="8"><a ngbNavLink>QR code</a></li>
        </ul>

        @if (tab === 0) {
            <div class="row">
                <div class="col-md-6">
                    @for (due of bundle.dues; track due.id) {
                        @if (due.status === 'Due' || due.status === 'InProgress') {
                            <div class="card mb-2">
                                <div class="card-body">
                                    <div>{{ due.status }}: {{ due.windowStart | date: 'EEE MMM d' }} - {{ due.windowEnd | date: 'EEE MMM d, y' }}</div>
                                    @if (canEdit) {
                                        <button type="button" class="btn btn-primary btn-sm mt-2" (click)="startInspection(due.id)">Start Inspection</button>
                                    }
                                </div>
                            </div>
                        }
                    }
                    <p>Acreage {{ bundle.site.acreage ?? '—' }} · Disturbed {{ bundle.site.disturbedAcreage ?? '—' }} · MS4 {{ bundle.site.ms4 || 'None' }}</p>
                    <p>{{ bundle.site.latitude }}, {{ bundle.site.longitude }}</p>
                </div>
                <div class="col-md-6">
                    <app-swppp-map [latitude]="bundle.site.latitude" [longitude]="bundle.site.longitude" [zoom]="14"></app-swppp-map>
                </div>
            </div>
        }

        @if (tab === 1) {
            <ul class="list-group mb-3">
                @for (assignment of bundle.assignments; track assignment.id) {
                    <li class="list-group-item">
                        {{ assignment.triggerType }}
                        @if (assignment.triggerType === 'Recurring') {
                            · {{ assignment.frequency }}
                        } @else {
                            · {{ assignment.precipThresholdInches }}"
                        }
                    </li>
                }
            </ul>
            @if (canEdit) {
                <div class="card"><div class="card-body">
                    <h5>New assignment</h5>
                    <div class="btn-group mb-2">
                        <button type="button" class="btn btn-sm" [class.btn-primary]="assignment.triggerType === 'Recurring'" [class.btn-outline-primary]="assignment.triggerType !== 'Recurring'" (click)="assignment.triggerType = 'Recurring'">Recurring</button>
                        <button type="button" class="btn btn-sm" [class.btn-primary]="assignment.triggerType === 'PostWeatherEvent'" [class.btn-outline-primary]="assignment.triggerType !== 'PostWeatherEvent'" (click)="assignment.triggerType = 'PostWeatherEvent'">Post weather event</button>
                    </div>
                    @if (assignment.triggerType === 'Recurring') {
                        <select class="form-select mb-2" [(ngModel)]="assignment.frequency">
                            <option value="WeeklyAnyDay">Weekly on any day</option>
                            <option value="Every14Days">Every 14 days</option>
                        </select>
                    } @else {
                        <div class="btn-group mb-2">
                            @for (amount of [0.1, 0.2, 0.25, 0.5, 0.75, 1]; track amount) {
                                <button type="button" class="btn btn-sm" [class.btn-primary]="assignment.precipThresholdInches === amount" [class.btn-outline-primary]="assignment.precipThresholdInches !== amount" (click)="assignment.precipThresholdInches = amount">{{ amount }}"</button>
                            }
                        </div>
                    }
                    <select class="form-select mb-2" [(ngModel)]="assignment.formId">
                        @for (form of forms; track form.id) {
                            <option [ngValue]="form.id">{{ form.name }}</option>
                        }
                    </select>
                    <label class="form-check"><input type="checkbox" class="form-check-input" [(ngModel)]="assignment.includeWeatherHistory" /> Include weather history</label>
                    <label class="form-check"><input type="checkbox" class="form-check-input" [(ngModel)]="assignment.allowSimultaneous" /> Allow simultaneous inspections</label>
                    <label class="form-label">Assigned people</label>
                    <select class="form-select mb-2" multiple [(ngModel)]="assignmentUserIds">
                        @for (user of users; track user.id) {
                            <option [value]="user.id">{{ user.displayName }}</option>
                        }
                    </select>
                    <div class="row g-2">
                        <div class="col">
                            <select class="form-select" [(ngModel)]="reminderType">
                                <option value="InspectionLatenessPreWarning">Inspection lateness warning</option>
                                <option value="TimeSinceLastInspection">Time since last inspection</option>
                                <option value="ActionItemLatenessPreWarning">Action item lateness warning</option>
                            </select>
                        </div>
                        <div class="col"><input class="form-control" type="number" [(ngModel)]="reminderDays" /> days</div>
                    </div>
                    <button type="button" class="btn btn-primary mt-2" (click)="saveAssignment()">Save assignment</button>
                </div></div>
            }
        }

        @if (tab === 2) {
            <table class="table">
                <tr>
                    <th>Name</th><th>Role</th><th>Email</th><th>Package</th><th>Public</th>
                    @if (canEdit) { <th></th> }
                </tr>
                @for (person of bundle.people; track person.id) {
                    <tr>
                        <td>{{ person.name }}</td>
                        <td>{{ person.role }}</td>
                        <td>{{ person.email }}</td>
                        <td>{{ person.receivesReports ? person.reportPackage : '' }}</td>
                        <td>{{ person.isPublicContact ? 'Yes' : '' }}</td>
                        @if (canEdit) {
                            <td class="text-nowrap">
                                <button type="button" class="btn btn-sm btn-outline-secondary me-1" (click)="editPerson(person)">Edit</button>
                                <button type="button" class="btn btn-sm btn-outline-danger" (click)="removePerson(person)">Remove</button>
                            </td>
                        }
                    </tr>
                }
            </table>
            @if (canEdit) {
                <div class="row g-2">
                    <div class="col"><input class="form-control" placeholder="Name" [(ngModel)]="person.name" /></div>
                    <div class="col"><input class="form-control" placeholder="Email" [(ngModel)]="person.email" /></div>
                    <div class="col"><input class="form-control" placeholder="Phone" [(ngModel)]="person.phone" /></div>
                    <div class="col">
                        <select class="form-select" [(ngModel)]="person.role">
                            <option>Inspector</option><option>BackupInspector</option><option>Operator</option><option>Owner</option><option>Regulator</option><option>SiteContact</option>
                        </select>
                    </div>
                    <div class="col">
                        <select class="form-select" [(ngModel)]="person.reportPackage">
                            <option value="ActionLog">Action log</option>
                            <option value="Report">Report</option>
                            <option value="ReportAndActions">Report and actions</option>
                        </select>
                    </div>
                </div>
                <label class="form-check mt-2"><input class="form-check-input" type="checkbox" [(ngModel)]="person.receivesReports" /> Receives reports</label>
                <label class="form-check"><input class="form-check-input" type="checkbox" [(ngModel)]="person.isPublicContact" /> Show on the public QR page</label>
                <label class="form-check"><input class="form-check-input" type="checkbox" [(ngModel)]="person.requiresActionSignoff" /> Must sign off action items</label>
                <div>
                    <button type="button" class="btn btn-primary mt-2" (click)="savePerson()">{{ editingPersonId ? 'Save changes' : 'Add person' }}</button>
                    @if (editingPersonId) {
                        <button type="button" class="btn btn-link" (click)="cancelPerson()">Cancel</button>
                    }
                </div>
            }
        }

        @if (tab === 3) {
            @for (doc of bundle.documents; track doc.id) {
                <div class="border rounded p-2 mb-2">
                    <strong>{{ doc.docType }}</strong> {{ doc.title }}
                    @if (doc.permitNumber) { · {{ doc.permitNumber }} {{ doc.permitType }} }
                    @if (doc.expirationDate) { · expires {{ doc.expirationDate }} }
                    @for (file of bundle.documentFiles; track file.id) {
                        @if (file.swpppDocumentId === doc.id) {
                            <div><a [href]="fileUrl(file)">{{ file.fileName }}</a></div>
                        }
                    }
                </div>
            }
            @if (canEdit) {
                <div class="row g-2">
                    <div class="col"><select class="form-select" [(ngModel)]="document.docType"><option>Permit</option><option>Plan</option><option>SiteMap</option><option>Document</option></select></div>
                    <div class="col"><input class="form-control" placeholder="Title" [(ngModel)]="document.title" /></div>
                    <div class="col"><input class="form-control" placeholder="Permit number" [(ngModel)]="document.permitNumber" /></div>
                    <div class="col"><input class="form-control" placeholder="Permit type" [(ngModel)]="document.permitType" /></div>
                </div>
                <div class="row g-2 mt-1">
                    <div class="col"><label class="form-label">Effective</label><input class="form-control" type="date" [(ngModel)]="document.effectiveDate" /></div>
                    <div class="col"><label class="form-label">Expires</label><input class="form-control" type="date" [(ngModel)]="document.expirationDate" /></div>
                    <div class="col"><label class="form-label">Remind days before</label><input class="form-control" type="number" [(ngModel)]="document.reminderDaysBefore" /></div>
                    <div class="col"><label class="form-label">File</label><input class="form-control" type="file" (change)="onDocumentFile($event)" /></div>
                </div>
                <input class="form-control mt-2" placeholder="Description" [(ngModel)]="document.permitDescription" />
                <button type="button" class="btn btn-primary mt-2" (click)="saveDocument()">Add document</button>
            }
        }

        @if (tab === 4) {
            @if (canEdit) {
                <button type="button" class="btn btn-primary mb-2" (click)="startOneOff()">Start inspection</button>
                <p class="text-muted small">Starts another inspection for this site. It does not replace the scheduled inspection for the week.</p>
            }
            <table class="table">
                <tr><th>When</th><th>Status</th><th></th></tr>
                @for (inspection of bundle.inspections; track inspection.id) {
                    <tr>
                        <td>{{ inspection.inspectionDateTime | date: 'MMM d, y h:mm a' }}</td>
                        <td>{{ inspection.status }}</td>
                        <td><a [routerLink]="['/field-tools/swppp/inspection', inspection.id]">Open</a></td>
                    </tr>
                }
            </table>
        }

        @if (tab === 5) {
            @for (item of bundle.actionItems; track item.id) {
                <div class="border rounded p-2 mb-2">
                    <div>{{ item.status }} · {{ item.description }}</div>
                    @if (item.completedByName) { <div class="small">Signed off by {{ item.completedByName }}</div> }
                    @if (canEdit && item.status === 'Completed') {
                        <button type="button" class="btn btn-sm btn-outline-primary" (click)="verify(item.id)">Mark verified</button>
                    }
                </div>
            }
            @if (canEdit) {
                <textarea class="form-control" rows="2" placeholder="Action item" [(ngModel)]="action.description"></textarea>
                <input class="form-control mt-1" placeholder="Location" [(ngModel)]="action.location" />
                <input class="form-control mt-1" type="date" [(ngModel)]="action.dueDate" />
                <button type="button" class="btn btn-primary mt-2" (click)="saveAction()">Add action item</button>
            }
        }

        @if (tab === 6) {
            <h5>Events</h5>
            <ul>
                @for (event of bundle.weatherEvents; track event.id) {
                    <li>{{ event.eventStart | date: 'MMM d, y' }} · {{ event.precipInches }}" · {{ event.stationId }}</li>
                }
            </ul>
            <h5>Recent precipitation</h5>
            <ul>
                @for (day of bundle.dailyPrecip; track day.id) {
                    <li>{{ day.date }} · {{ day.precipInches }}"</li>
                }
            </ul>
        }

        @if (tab === 7) {
            @for (note of bundle.notes; track note.id) {
                <p>{{ note.text }}</p>
            }
            @if (canEdit) {
                <textarea class="form-control" rows="3" [(ngModel)]="noteText"></textarea>
                <button type="button" class="btn btn-primary mt-2" (click)="saveNote()">Add note</button>
            }
        }

        @if (tab === 8) {
            <p>Print this code for the site board. It opens a public page with the company, project, and contacts. Reports stay private.</p>
            <img [src]="qrUrl()" alt="Site QR code" width="240" height="240" />
            <div><button type="button" class="btn btn-outline-secondary mt-2" (click)="printQr()">Print</button></div>
        }
    }
</div>
